<template>
  <div class="tabs-view-container">
    <div ref="scrollContainer" class="scroll-container" @wheel.prevent="handleScroll">
      <div class="tab-back-iocn" @click="handelBackPage">
        <i class="el-icon-arrow-left " />
      </div>
      <div class="tab-refresh-iocn" @click="handelBackOut">
        <svg-icon icon-class="icon-side-home" />
      </div>
      <div class="tab-refresh-iocn" @click="handelRefreshPage">
        <i class="el-icon-refresh " style="font-size:16px" />
      </div>

      <div ref="scrollWrapper" class="scroll-wrapper" :style="{left: left + 'px'}">
        <div v-for="(tag,index) in tagList" ref="tag" :key="index" class="tabs-view">
          <el-tag size="medium" :type="(groupIndex === index)?'':'info'" :color="(groupIndex === index)?'':'#ffff'" @click="handelChangeGroupIndex(index,tag.fullPath)">
            <div class="layout-topTag-names">
              <span class="tabs_name_body tabs_name_list">
                <span>{{ tag.parentName||tag.meta.title }}</span>
                <!-- 存在子项 -->
                <template v-if="tag.subitemName">
                  <i class="el-icon-arrow-right" />
                  <span>{{ tag.subitemName }}</span>
                </template>
              </span>
              <!-- <i class="el-icon-close layout-topTag-closeIcon" size @click.stop="handelDelGroup(index)" /> -->
            </div>
          </el-tag>
        </div>
        <!-- 展示新增按钮  -->
        <!-- <span class="tabs-view layout-addNewView-add">
          <el-tag v-if="tagList.length<5" size="medium" type="info" style="background-color:#ffff" @click="handelAddGroup">
            <i class="el-icon-plus" />
            <span>新增</span>
          </el-tag>
        </span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const padding = 15 // tag's padding
const defaultRouter = { name: 'Dashboard', path: '/', meta: { title: '个人主页', keepAlive: true }} // 默认页面

export default {
  data() {
    return {
      left: 0
    }
  },
  computed: {
    ...mapGetters(['permissionMenus']),
    visitedViews() {
      return this.$store.state.app.visitedViews
    },
    // 当前选中的分组
    groupIndex() {
      return this.$store.state.app.groupIndex
    },
    // 当前的标签
    tagList() {
      return this.$store.state.app.groupArray.map(viewList => {
        const lastItem = viewList[viewList.length - 1 ? viewList.length - 1 : 0] || {}
        return lastItem
      })
    },
    history() {
      return this.$store.state.app.groupArray[this.groupIndex]
    },
    colorInfo() {
      return this.$store.state.user.userData.colorInfo
    },
    groupCache() {
      return this.$store.state.app.groupCache
    },
    groupArray() {
      return this.$store.state.app.groupArray
    }
  },
  methods: {
    /**
     * 切换选中tag页面
     * @param {*} index 切换分组的下标
     */
    handelChangeGroupIndex(index, path) {
      // 切换index
      this.$store.dispatch('setGroupIndex', index)
      this.$route.params.changeTab = true
      this.$router.push({
        path: path || '/'
      })
    },
    /**
     * 新增tag页面
     */
    handelAddGroup() {
      this.$route.params.changeTab = true
      // 增加分组
      this.$store.dispatch('addGroup', defaultRouter)
      this.$store.dispatch('setGroupIndex', this.groupArray.length - 1)
      // 从当前首页跳转到新建首页不会触发路由，手动追加
      this.$router.push({
        path: '/dashboard?tab=' + this.groupIndex
      })
    },
    /**
     * 删除tag
     * @param {*} index 删除分组下标
     */
    handelDelGroup(index) {
      this.$store.dispatch('delGroup', index).then((move) => {
        if (move === true) {
          const history = this.history || []
          const lastPath = history[history.length - 1 ? history.length - 1 : 0] || {}
          this.$route.params.changeTab = true
          this.$router.push({
            path: lastPath.fullPath || '/'
          })
        }
      })
    },
    // 一键返回 (暂定返回首页)
    handelBackOut() {
      // 单店登录禁用返回按钮
      if (sessionStorage.getItem('defaultPath')) {
        this.$router.push({
          path: sessionStorage.getItem('defaultPath')
        })
      } else {
        this.$router.push({
          path: '/dashboard'
        })
      }
    },
    // 返回上一页
    handelBackPage() {
      this.$route.params.changeTab = false
      const lastPath = this.history[this.history.length - 2] || undefined
      if (lastPath) {
        // 是否存在缓存，存在缓存进行删除
        if (this.groupCache[this.catchKey()]) {
          this.$store.dispatch('delCacheItem', this.catchKey())
        }
        // 移除最近两项，后续进行追加
        this.$store.dispatch('delMultiRouterItem', { index: this.history.length - 2, len: 2 })
        this.$router.push({
          path: lastPath.fullPath || '/'
        })
      }
    },
    // 刷新当前页面
    handelRefreshPage() {
      // 是否存在缓存，存在缓存进行删除
      if (this.groupCache[this.catchKey()]) {
        this.$store.dispatch('delCacheItem', this.catchKey())
      }
      // 调用父级组件v-if，强制重新渲染
      this.$emit('refreshPage')
    },
    // 获取路径信息
    generateRoute(to) {
      // 当前全路径
      const currentPath = this.$route.matched
      if (currentPath[currentPath.length - 1].name) {
        // 路径name,后续展示使用
        const { 0: parentName, 1: subitemName } = currentPath.map(item => item.name)
        const view = currentPath[currentPath.length - 1]
        return {
          toRouter: to, // 保留跳转地址,点击返回按钮/历史返回在路由钩子中判断
          compName: view.components && view.components.default && view.components.default.name,
          ...view,
          parentName,
          subitemName
        }
      }
      this.$route.matched[0].path = '/dashboard'
      return this.$route.matched[0]
    },

    /** 当前的key */
    catchKey() {
      //  获取当前访问的组件
      const currentMatched = this.$router.history.current.matched
      const currentInfo = currentMatched[currentMatched.length - 1 ? currentMatched.length - 1 : 0].components.default || {}
      return `${this.groupIndex}/${currentInfo.name}`
    },

    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 3
      const $container = this.$refs.scrollContainer
      const $containerWidth = $container.offsetWidth
      const $wrapper = this.$refs.scrollWrapper
      const $wrapperWidth = $wrapper.offsetWidth

      if (eventDelta > 0) {
        this.left = Math.min(0, this.left + eventDelta)
      } else {
        if ($containerWidth - padding < $wrapperWidth) {
          if (this.left < -($wrapperWidth - $containerWidth + padding)) {
            this.left = this.left
          } else {
            this.left = Math.max(
              this.left + eventDelta,
              $containerWidth - $wrapperWidth - padding
            )
          }
        } else {
          this.left = 0
        }
      }
    },
    moveToTarget($target) {
      const $container = this.$refs.scrollContainer
      const $containerWidth = $container.offsetWidth
      const $targetLeft = $target.offsetLeft
      const $targetWidth = $target.offsetWidth

      if ($targetLeft < -this.left) {
        // tag in the left
        this.left = -$targetLeft + padding
      } else if (
        $targetLeft + padding > -this.left &&
        $targetLeft + $targetWidth < -this.left + $containerWidth - padding
      ) {
        // tag in the current view
        // eslint-disable-line
      } else {
        // tag in the right
        this.left = -($targetLeft - ($containerWidth - $targetWidth) + padding)
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "src/styles/variables.scss";

.tab-back-iocn,
.tab-refresh-iocn {
  cursor: pointer;
  padding: 0 16px;
  font-size: 16px;
  line-height: 60px;
  color: #4b4b4b;
}

.top_tags_name {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 60px;
  flex-wrap: nowrap;
}
.tabs_name_body {
  flex: 1;
  overflow: hidden;
  text-align: center;
  display: inline-block;
}
.tabs_name_list {
  height: 60px;
  line-height: 60px;
}
.layout-topTag-names {
  min-width: 164px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}
.layout-topTag-closeIcon {
  font-size: 20px !important;
  top: 1px !important;
  right: 0px !important;
  margin-left: 10px;
}
.layout-topTag-closeIcon:hover {
  font-weight: 900;
}
.layout-addNewView-add {
  text-align: center;
  width: 100px;
  cursor: pointer;

  .el-icon-plus {
    font-size: 16px;
    position: relative;
    top: 1px;
  }
  .el-icon-plus:hover {
    font-weight: 900;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/variables.scss";

.tabs-view-container {
  display: flex;
  height: 60px;
  align-items: flex-start;
  justify-content: flex-start;
  .tabs-view {
    cursor: pointer;
    height: 60px;
    .el-tag {
      border-radius: 0 !important;
      height: 60px;
      box-sizing: border-box;
      line-height: 60px;
      position: relative;
      color: $mainColor;
      background-color: $minorColor;
      border: none;
    }
    .el-tag--info {
      color: #4b4b4b;
    }
  }
  .layout-addNewView-add {
    .el-tag {
      font-size: 14px;
    }
  }
}
.scroll-container {
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  height: 60px;
  display: flex;
  .scroll-wrapper {
    height: 60px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
}
</style>
